function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import digitalData from 'digital-data';
import { setAnalytics } from '../../../thd-analytics-utils.js';
import { ERROR, INSTANT_CHECKOUT } from '../../../constants.js';

// https://github.com/one-thd/ocm_pd_experience_customer-account-pojob-proallowance
export function proAllowancePage() {
  const trackEvent = event => {
    digitalData.event = digitalData.event || [];
    digitalData.event.push(event);
  };
  const proallowanceEvents = {
    error: _ref => {
      let {
        output
      } = _ref;
      const {
        type,
        displayType,
        pageSection,
        message,
        code
      } = output;
      digitalData.page = {
        error: {
          type,
          displayType,
          pageSection,
          message,
          code
        }
      };
      setAnalytics(digitalData);
    },
    postPageErrors: _ref2 => {
      let {
        output
      } = _ref2;
      const DDOEvent = {
        category: {
          primaryCategory: ERROR
        },
        eventInfo: {
          eventName: 'post page error',
          error: [_objectSpread({}, output)]
        }
      };
      trackEvent(DDOEvent);
    }
  };
  window.LIFE_CYCLE_EVENT_BUS.on('pro-allowance.page-load-error', proallowanceEvents.error);
  window.LIFE_CYCLE_EVENT_BUS.on('pro-allowance.post-page-error', proallowanceEvents.postPageErrors);
}
//# sourceMappingURL=proAllowance.js.map